<template>
  <Modal :value="show" :title="$t('self_check_result')" @on-visible-change="changeModal"   width="80%" scrollable footer-hide transfer draggable>
    <Tabs value="current" v-model="tabName">
      <TabPane :label="$t('self_check_current_result')" name="current"><tables
        id="now-search"
        searchable
        search-place="top"
        pageable
        page-place="bottom"
        :page-size="10"
        show-total
        :height="tableHeight"
        v-model="echoResultData"
        :columns="columns"
        :searchColumns="newColumns"
        :dataTotal="dataTotal"
        @changePageIndex="initSearch"
        @on-sort-change="sortChange"
        typeName="selfCheck"
      ></tables></TabPane>
      <TabPane :label="$t('self_check_history_result')" name="history"><tables
        id="history-search"
        searchable
        search-place="top"
        :searchColumns="newColumns"
        pageable
        page-place="bottom"
        exportable
        :downTemp="false"
        export-place="top"
        :hasExportFileRole="true"
        :page-size="10"
        show-total
        :height="tableHeight"
        v-model="echoHistoryResultData"
        :columns="columns"
        :dataTotal="dataTotalHis"
        @changePageIndex="initSearchHistory"
        @on-sort-change="sortHistoryChange"
        @exportExcel="exportExcel"
        typeName="selfCheck"
      ></tables></TabPane>
    </Tabs>
    <!--<tables
      searchable
      search-place="top"
      pageable
      page-place="bottom"
      :page-size="10"
      show-total
      height="520px"
      v-model="echoResultData"
      :columns="columns"
      @on-sort-change="sortChange"
    ></tables>-->
  </Modal>
</template>

<script>
import Tables from '@/components/tables/tables'
import {
  getSelfCheckResultForPage,
  getSelfCheckResultByExtensForPage,
  getSelfCheckHistoryResultForPage,
  getSelfCheckHistoryResultByExtensForPage,
  downloadResult
} from '@/api/selfCheck';
import {forEach} from '../../libs/tools'
import {dateToString,localRead} from '@/libs/util'
import {accessToken} from "../../libs/safekodo";

export default {
  name: 'selfCheck-result',
  components: {Tables},
  props:['show','id','extens'],
  data(){
    return{
      result:[],
      historyResult:[],
      employeeName:"",
      telNumber:"",
      upTime:"",
      echoTime:"",
      echoResult:"",
      properties:"",
      direction:"",
      currPage:1,
      pageLimit:10,
      tabName:'current',
      resultList:[{"id":"0","name":this.$t('self_result_nostart')},{"id":"1","name":this.$t('self_result_checking')},
        {"id":"2","name":this.$t('self_result_normal')},{"id":"3,4,5,6","name":this.$t('self_result_abnormal')}],
      dataTotalHis:0,
      dataTotal:0,
      propertiesHis:"",
      directionHis:"",
      currPageHis:1,
      pageLimitHis:10,
      tableHeight: '750',
    }
  },
  methods:{
    initSearch(param,index,pageSize){
      if(param) {
        this.employeeName = param.employeeName ? param.employeeName : "";
        this.telNumber = param.telNumber ? param.telNumber : "";
        this.upTime = param.upTime ? param.upTime : [];
        this.echoTime = param.echoTime ? param.echoTime : [];
        this.echoResult = param.echoResult ? param.echoResult : "";

        this.compareVolume = param.comparevolume ? param.comparevolume : "";
        this.level = param.level ? param.level : "";
        this.model = param.model ? param.model : "";
      }
      if(index){
        this.currPage = index;
      }
      if(pageSize){
        this.pageLimit = pageSize;
      }
      this.loadResultData();
    },
    initSearchHistory(param,index,pageSize){
      if(param) {
        this.employeeName = param.employeeName ? param.employeeName : "";
        this.telNumber = param.telNumber ? param.telNumber : "";
        this.upTime = param.upTime ? param.upTime : [];
        this.echoTime = param.echoTime ? param.echoTime : [];
        this.echoResult = param.echoResult ? param.echoResult : "";

        this.compareVolume = param.comparevolume ? param.comparevolume : "";
        this.level = param.level ? param.level : "";
        this.model = param.model ? param.model : "";
      }
      if(index){
        this.currPageHis = index;
      }
      if(pageSize){
        this.pageLimitHis = pageSize;
      }
      this.loadHistoryResultData();
    },
    changeModal(val) {
      this.$emit('closeModal',val)
    },
    sortChange(column) {
      this.direction = column.order;
      this.properties = column.key;
      if("echoTime" == column.key){
        this.properties = "echo_time";
      }
      if("upTime" == column.key){
        this.properties = "up_time";
      }
      if("result" == column.key){
        this.properties = "echo_result";
      }
      this.initSearch();
    },
    sortHistoryChange(column) {
      this.directionHis = column.order;
      this.propertiesHis = column.key;
      if("echoTime" == column.key){
        this.propertiesHis = "echo_time";
      }
      if("upTime" == column.key){
        this.propertiesHis = "up_time";
      }
      if("result" == column.key){
        this.propertiesHis = "echo_result";
      }
      this.initSearchHistory();
    },
    loadResultData(){
      let id = this.id
      let extens = this.extens
      this.result = []
      let upTimeBegin = this.upTime && this.upTime[0] ? this.upTime[0] : "";
      let upTimeEnd = this.upTime && this.upTime[1] ? this.upTime[1] : "";
      let echoTimeBegin = this.echoTime && this.echoTime[0] ? this.echoTime[0] : "";
      let echoTimeEnd = this.echoTime && this.echoTime[1] ? this.echoTime[1] : "";
      let param={
        employeeName:this.employeeName,
        telNumber:this.telNumber,
        upTimeBegin:upTimeBegin,
        upTimeEnd:upTimeEnd,
        echoTimeBegin:echoTimeBegin,
        echoTimeEnd:echoTimeEnd,
        echoResult:this.echoResult,
        properties:this.properties ? this.properties : "",
        direction:this.direction ? this.direction : "",
        currPage:this.currPage,
        pageLimit:this.pageLimit,
      };
      if (id) {
        param.taskId = id;
        getSelfCheckResultForPage(param).then(res=>{
          let response = res.data
          if (response.code === 200){
            this.dataTotal = response.data.totalCount
            this.result = response.data.list
          }
        })
      }
      if (extens) {
        param.extens = extens;
        getSelfCheckResultByExtensForPage(param).then(res=>{
          let response = res.data
          if (response.code === 200){
            this.dataTotal = response.data.totalCount
            this.result = response.data.list
          }
        })
      }

    },
    loadHistoryResultData(){
      let id = this.id
      let extens = this.extens
      this.result = []
      let upTimeBegin = this.upTime && this.upTime[0] ? this.upTime[0] : "";
      let upTimeEnd = this.upTime && this.upTime[1] ? this.upTime[1] : "";
      let echoTimeBegin = this.echoTime && this.echoTime[0] ? this.echoTime[0] : "";
      let echoTimeEnd = this.echoTime && this.echoTime[1] ? this.echoTime[1] : "";
      let param={
        employeeName:this.employeeName,
        telNumber:this.telNumber,
        upTimeBegin:upTimeBegin,
        upTimeEnd:upTimeEnd,
        echoTimeBegin:echoTimeBegin,
        echoTimeEnd:echoTimeEnd,
        echoResult:this.echoResult,
        properties:this.propertiesHis ? this.propertiesHis : "",
        direction:this.directionHis ? this.directionHis : "",
        currPage:this.currPageHis,
        pageLimit:this.pageLimitHis,
      };
      if (id) {
        param.taskId = id;
        getSelfCheckHistoryResultForPage(param).then(res=>{
          let response = res.data
          if (response.code === 200){
            this.dataTotalHis = response.data.totalCount
            this.historyResult = response.data.list
          }
        })
      }
      if (extens) {
        param.extens = extens;
        getSelfCheckHistoryResultByExtensForPage(param).then(res=>{
          let response = res.data
          if (response.code === 200){
            this.dataTotalHis = response.data.totalCount
            this.historyResult = response.data.list
          }
        })
      }

    },
    echoResultLocal(result) {
      if (result === '0') {
        return this.$t('self_result_nostart')
      }else if (result === '1') {
        return this.$t('self_result_checking')
      } else if (result === '2') {
        return this.$t('self_result_normal')
      } else if (result === '3' || result === '4' || result === '5' || result === '6') {
        return this.$t('self_result_abnormal')
      }
      return ''
    },
    abnormalTip(tip) {
      switch (tip) {
        case '3':
          return this.$t('self_fail_device')
        case '4':
          return this.$t('self_fail_busy')
        case '5':
          return this.$t('self_fail_overtime')
        case '6':
          return this.$t('self_fail_offline')
        default:
          return ''
      }
    },
    exportExcel(columns, data) {
      let id = this.id
      let extens = this.extens
      this.result = []
      let upTimeBegin = this.upTime && this.upTime[0] ? this.upTime[0] : "";
      let upTimeEnd = this.upTime && this.upTime[1] ? this.upTime[1] : "";
      let echoTimeBegin = this.echoTime && this.echoTime[0] ? this.echoTime[0] : "";
      let echoTimeEnd = this.echoTime && this.echoTime[1] ? this.echoTime[1] : "";
      let params={
        taskId:id,
        extens:extens,
        employeeName:this.employeeName,
        telNumber:this.telNumber,
        upTimeBegin:upTimeBegin,
        upTimeEnd:upTimeEnd,
        echoTimeBegin:echoTimeBegin,
        echoTimeEnd:echoTimeEnd,
        echoResult:this.echoResult,
        properties:this.propertiesHis ? this.propertiesHis : "",
        direction:this.directionHis ? this.directionHis : "",
        language:localRead('local') == 'zh-tw' || localRead('local') == 'zh-TW' ? 'tw' : localRead('local')
      };
      if (data.length) {
        downloadResult(params)
      } else {
        this.$Message.info(this.$t('no_data'))
      }
    },
    getScreenInfo: function () {
      let contentHeight = this.sysHeight - 103
      this.tableHeight = contentHeight - 102 - 52 - 74
    },
  },
  mounted() {
    this.getScreenInfo()
  },
  computed:{
    sysHeight: function () {
      return this.$store.state.app.sysHeight
    },
    sysWidth: function () {
      return this.$store.state.app.sysWidth
    },
    newColumns() {
      return [
        {title: this.$t('device'), oldKey: 'telNumber', key: 'telNumber', type: 'text', value: ''},
        {title: this.$t('self_name'), oldKey: 'employeeName', key: 'employeeName', type: 'text', value: ''},
        {title: this.$t('start_time'), oldKey: 'echoTime', key: 'echoTime', type: 'time', value: [dateToString(new Date())+" 00:00:00" ,dateToString(new Date())+" 23:59:59"]},
        {title: this.$t('self_result_uptime'), oldKey: 'upTime', key: 'upTime', type: 'time', value: [dateToString(new Date())+" 00:00:00" ,dateToString(new Date())+" 23:59:59"]},
        {title: this.$t('self_result'), oldKey: 'echoResult', key: 'echoResult', type: 'select', value: '',list:this.resultList},
      ];
    },
    columns(){
      return [
        {
          title:this.$t('device'),
          key:'telNumber',
          align:'center'
        },
        {
          title:this.$t('self_name'),
          key:'employeeName',
          align: 'center',
          ellipsis: true,
          tooltip: true
        },
        {
          title:this.$t('start_time'),
          key: 'echoTime',
          align: 'center',
          sortable:'custom',
          dateTime: true,
          ellipsis:true,
          tooltip:true
        },
        {
          title: this.$t('self_result_uptime'),
          key: 'upTime',
          align: 'center',
          sortable:'custom',
          dateTime: true,
          ellipsis:true,
          tooltip:true
        },
        {
          title: this.$t('b_status'),
          key: 'newState',
          align: 'center',
          sortable:'custom'
        },
        {
          title: this.$t('self_result'),
          key: 'result',
          align: 'center',
          sortable:'custom'
        },
        {
          title: this.$t('self_fail_tip'),
          key: 'tip',
          align: 'center',
          ellipsis:true,
          tooltip:true
        }
      ]
    },
    echoResultData() {
      let data = this.result
      if (data && data.length > 0) {
        forEach(data,item=>{
          item.result = this.echoResultLocal(item.echoResult+"")
          item.newState = !item.employeeState ? "" : item.employeeState == '1' ? this.$t('inline') : this.$t('OffLine');
          item.tip = this.abnormalTip(item.echoResult+"")
        })
        return data
      }
      return []
    },
    echoHistoryResultData() {
      let data = this.historyResult
      if (data && data.length > 0) {
        forEach(data,item=>{
          item.result = this.echoResultLocal(item.echoResult+"")
          item.newState = !item.employeeState ? "" : item.employeeState == '1' ? this.$t('inline') : this.$t('OffLine');
          item.tip = this.abnormalTip(item.echoResult+"")
        })
        return data
      }
      return []
    },
  },
  watch:{
    show:{
      deep:true,
      handler(value) {
        if (value) {
          this.loadResultData()
          this.loadHistoryResultData()
        }
      }
    },
    sysHeight: function (value, oldvalue) {
      this.getScreenInfo()
    },
    sysWidth: function () {
      this.getScreenInfo()
    },
  }

}
</script>
<style>
  #now-search .search-table{
    width: 55.5%;
    left: 0px!important;
  }
  #history-search .search-table{
    width: 55.5%;
    left: auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/self_check/selfCheck-result.vue